if (!customElements.get('cart-drawer-addon')) {
  customElements.define(
    'cart-drawer-addon',
    class CartDrawerAddon extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.cart-drawer-addon__button');
        this.variantId = this.dataset.variantId;

        if (this.button && !this.button.disabled) {
          this.button.addEventListener('click', this.onAddToCart.bind(this));
        }
      }

      onAddToCart(evt) {
        evt.preventDefault();

        if (this.button.getAttribute('aria-disabled') === 'true') return;

        // Show loading state
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        const buttonText = this.button.querySelector('.cart-drawer-addon__button-text');
        const spinner = this.button.querySelector('.cart-drawer-addon__spinner');
        if (buttonText) buttonText.classList.add('hidden');
        if (spinner) spinner.classList.remove('hidden');

        // Get the cart-drawer element for re-rendering
        const cartDrawer = document.querySelector('cart-drawer');

        // Build sections to render (same as product-form.js pattern)
        const sections = cartDrawer
          ? cartDrawer.getSectionsToRender().map((section) => section.id)
          : [];

        const body = JSON.stringify({
          id: parseInt(this.variantId),
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname,
        });

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: body,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Error handling - item could not be added
              console.error('Add-on error:', response.description);
              this.resetButton();
              return;
            }

            // Publish cart update event (matches product-form.js pattern)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-addon',
              productVariantId: this.variantId,
              cartData: response,
            });

            // Re-render the cart drawer with updated sections
            if (cartDrawer) {
              if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(response);
            }
          })
          .catch((error) => {
            console.error('Add-on fetch error:', error);
            this.resetButton();
          });
      }

      resetButton() {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
        const buttonText = this.button.querySelector('.cart-drawer-addon__button-text');
        const spinner = this.button.querySelector('.cart-drawer-addon__spinner');
        if (buttonText) buttonText.classList.remove('hidden');
        if (spinner) spinner.classList.add('hidden');
      }
    }
  );
}
